module.exports = __webpack_public_path__ + "static/img/gy-top.fac92396.png";